/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import { set } from 'lodash-es';
import launchIntercom from '@/assets/js/intercom';

// initial state
const state = {
  isHidden: true,
  isMessengerOpen: false,
};

// getters
const getters = {
  isMessengerOpen: (state) => state.isMessengerOpen,
};

// actions
const actions = {
  async boot({ state, commit }) {
    await launchIntercom();
    window.Intercom('boot', {
      app_id: 'x5v469o5',
      hide_default_launcher: state.isHidden,
    });
    window.Intercom('onHide', () => {
      commit('SET_VALUE', { isMessengerOpen: false });
      if (window.screen.width < 768) {
        window.Intercom('update', {
          hide_default_launcher: true,
        });
      }
    });
    window.Intercom('onShow', () => {
      commit('SET_VALUE', { isMessengerOpen: true });
    });
    if (window.screen.width > 768) {
      window.Intercom('update', {
        hide_default_launcher: false,
      });
    }
  },
  showLauncher() {
    window.Intercom('update', {
      hide_default_launcher: false,
    });
  },
  hideLauncher() {
    window.Intercom('update', {
      hide_default_launcher: true,
    });
  },
  openMessenger() {
    window.Intercom('show');
    return Promise.resolve();
  },
  closeMessenger() {
    window.Intercom('hide');
  },
  setValue({ commit }, object) {
    commit('SET_VALUE', object);
  },
  setValueWithPath({ commit }, object) {
    commit('SET_VALUE_WITH_PATH', object);
  },
};

// mutations
const mutations = {
  SET_VALUE(state, object) {
    const [key] = Object.keys(object);
    state[key] = object[key];
  },
  SET_VALUE_WITH_PATH(state, { value, path }) {
    set(state, path, value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
